import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ExcelService } from '../../../services/excel/excel.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DialogProcesandoComponent } from '../../../components/shared/dialog-procesando/dialog-procesando.component';

declare var jQuery:any;

@Component({
  selector: 'configTools',
  templateUrl: 'configTools.template.html',
  styleUrls: ['./configTools.component.css']
})
export class ConfigToolsComponent implements OnInit, OnChanges {

  @Input() Title: string = ""; 
  @Input() Errors: boolean=false;
  @Input() rowsExport: any; 
  @Input() eliminando: boolean=false;
  @Input() bNew: boolean= true;
  @Input() bImportExport: string="A";
  @Input() Permiso: boolean=true;
  
  @Output() AddChange = new EventEmitter<boolean>();
  @Output() ImportChange = new EventEmitter<[]>();

  constructor(
      private modalService: BsModalService,
      private excelService: ExcelService,
      private snackBar: MatSnackBar,
      private dialog: MatDialog
      ) { }

  myfile: any = [];
  rowsImport: any;
  bImport: boolean = true;
  bExport: boolean = true;

  ngOnInit(): void {

    switch(this.bImportExport) { 
      case 'N': { 
        //N=Ninguno - No deja importar ni exportar
        this.bImport = false;
        this.bExport = false;
        break; 
      } 
      case 'E': { 
        //E=Exporta - No deja importar
        this.bImport = false;
        break; 
      } 
      case 'I': { 
        //I=Importa - No deja exportar
        this.bExport = false;
        break; 
      } 
      default: { 
        break; 
      } 
    }; 
  }
 
  ngOnChanges(changes: SimpleChanges) {
   
  }

  public add(e):void {
      this.AddChange.emit(true);
  }

  // Exporto a excel, paso como parametreo el array de datos y el nombre del archivo que quiero poner.
  exportExcel()
  {    
    if (this.rowsExport == null || this.rowsExport.length == 0){
      this.snackBar.open('No se encontraron registros', "OK", { duration: 10000 });
    }else{
      this.excelService.exportExcel(this.rowsExport, this.Title);
    }
  }

  // Exporto a excel, paso como parametreo el array de datos y el nombre del archivo que quiero poner.
  exportTxt()
  {    
    if (this.rowsExport == null){
      this.snackBar.open('No se encontraron registros', "OK", { duration: 10000 });
    }else{
      this.excelService.exportTxt(this.rowsExport, this.Title);
    }
  }

  onFileChange(evt: any) {
    var dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
      width: '400px'
    });
    dialogProcesandoRef.componentInstance.Mensaje = "Procesando...";

      if (evt.files.length !== 1) {
        this.ImportChange.emit(this.rowsImport);
        throw new Error('No se pueden importar multiples archivos');
      }
  
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
  
        const bstr: string = e.target.result;
        const data = <any[]>this.excelService.importFromFile(bstr);
        const header = Object.getOwnPropertyNames(this.rowsExport[0]);
        const importedData = data.slice(1);
  
        this.rowsImport = importedData.map(arr => {
          const obj = {};
          for (let i = 0; i < header.length; i++) {
            const k = header[i];
            obj[k] = arr[i];
          }
          return obj;
        })
        this.ImportChange.emit(this.rowsImport);

        dialogProcesandoRef.close();
      };
      reader.readAsBinaryString(evt.files[0]);
      this.myfile = [];
  }

  recycle()
  {
  }
}
